import React, {useState, useEffect, useContext} from 'react';
import {Grid, Typography, FormControl} from '@material-ui/core';
import {Controller} from 'react-hook-form';
import {useForm} from 'react-hook-form';
import {useDispatch, useSelector} from 'react-redux';
import {postRateTable, getServiceIDs, getClientIds} from '../../redux/reducers/EditRateCard';
import RateTable from './RateTable';
import PageLoader from '../../components/PageLoader';
import {ThemeContext} from '../../themes/ThemeProvider';
import GuiAutoComplete from '../../components/FormComponents/GuiAutoComplete';
import GuiTextField from '../../components/FormComponents/GuiTextField';

const ClientService = () => {
  const {reusableInputStyles} = useContext(ThemeContext);
  const classes = reusableInputStyles();

  const dispatch = useDispatch();

  const [clientID, setClientID] = useState();
  const [servID, setServID] = useState();

  const {cliId, servId, isLoadingView, rateTable} = useSelector(
    ({editRateTable}) => editRateTable,
  );
  const initialValues = {
    clienID: '',
    serviId: '',
  };

  const {handleSubmit, control} = useForm({
    defaultValues: initialValues,
  });

  const onSubmit = (data) => {};

  useEffect(() => {
    dispatch(getClientIds());
    setServID(servId.services);
  }, [servId]);

  useEffect(() => {
    if (clientID !== undefined && servID !== undefined) {
      dispatch(
        postRateTable({
          client_id: clientID,
          service_type_id: servID != undefined ? servID[0]?.service_id : '',
        }),
      );
    }
  }, [clientID, servID]);

  return (
    <div>
      <div className={classes.cardStyling}>
        <div className="mt-2">
          <Typography variant="h4" className="px-2">
            View Rate Card for Client / Hospital Services
          </Typography>
        </div>
        <form onSubmit={handleSubmit(onSubmit)} noValidate>
          <Grid container className="mt-3">
            <Grid className="px-1 form-group col-sm-6 col-xs-12 col-md-4 col-lg-3">
              <FormControl margin="dense" variant="outlined" fullWidth>
                <Controller
                  render={(props) => (
                    <GuiAutoComplete
                      classes={{
                        popper: classes.popper,
                        option: classes.option,
                      }}
                      {...props}
                      options={cliId?.length > 0 ? cliId : []}
                      getOptionLabel={(option) => option?.client_id}
                      getOptionSelected={(option, value) =>
                        value === undefined || value === '' || option.client_id === value.client_id
                      }
                      renderInput={(params) => (
                        <GuiTextField
                          {...params}
                          className={` ${classes.labelName} ${classes.selectLabel}`}
                          label="Client ID"
                          placeholder="Select Client ID"
                          InputLabelProps={{
                            shrink: true,
                          }}
                          variant="outlined"
                        />
                      )}
                      onChange={(_, data) => {
                        props.onChange(data);
                        if (data !== null) {
                          dispatch(getServiceIDs({client_id: data.client_id}));
                          setClientID(data.client_id);
                        }
                      }}
                    />
                  )}
                  name="clienID"
                  control={control}
                />
              </FormControl>
            </Grid>
            <Grid className="px-1 form-group col-sm-6 col-xs-12 col-md-4 col-lg-3">
              <FormControl margin="dense" variant="outlined" fullWidth>
                <Controller
                  render={(props) => (
                    <GuiAutoComplete
                      classes={{
                        popper: classes.popper,
                        option: classes.option,
                      }}
                      {...props}
                      options={servID != undefined ? servID : []}
                      value={clientID && servID != undefined ? servID[0] : ''}
                      getOptionLabel={(option) => option.service_type}
                      getOptionSelected={(option, value) =>
                        value === undefined ||
                        value === '' ||
                        option.service_type === value.service_type
                      }
                      renderInput={(params) => (
                        <GuiTextField
                          {...params}
                          className={` ${classes.labelName} ${classes.selectLabel}`}
                          label="Service ID"
                          placeholder="Select Service ID"
                          InputLabelProps={{
                            shrink: true,
                          }}
                          variant="outlined"
                        />
                      )}
                      onChange={(_, data) => props.onChange(data)}
                    />
                  )}
                  name="serviId"
                  control={control}
                />
              </FormControl>
            </Grid>
          </Grid>
        </form>
        <div>
          <RateTable rateData={rateTable} />
        </div>
      </div>
      {isLoadingView && <PageLoader />}
    </div>
  );
};

export default ClientService;
